module.exports = new __parcel__URL__("report-cycle-time.13464e88.svg").toString();